module.exports = __webpack_public_path__ + "static/media/successOnboarding.65d3bb14.png";